/**
 * Trigger: tr_exchanges_update
 * Purpose: Update account balances when exchange details change
 * Table: exchanges
 * Event: UPDATE OF account_id, currency_in_id, currency_out_id, exchange_date, amount_out, amount_in
 */
export const TR_EXCHANGES_UPDATE = `
CREATE TRIGGER tr_exchanges_update
UPDATE OF account_id, currency_in_id, currency_out_id, exchange_date, amount_out, amount_in ON exchanges
BEGIN
  UPDATE account_balances
  SET exchanges_amount = exchanges_amount + old.amount_out
  WHERE account_id = old.account_id
    AND currency_id = old.currency_out_id;

  UPDATE account_daily_balances
  SET exchanges_amount = exchanges_amount + old.amount_out
  WHERE account_id = old.account_id
    AND currency_id = old.currency_out_id
    AND balance_date = old.exchange_date;

  UPDATE account_balances
  SET exchanges_amount = exchanges_amount - old.amount_in
  WHERE account_id = old.account_id
    AND currency_id = old.currency_in_id;

  UPDATE account_daily_balances
  SET exchanges_amount = exchanges_amount - old.amount_in
  WHERE account_id = old.account_id
    AND currency_id = old.currency_in_id
    AND balance_date = old.exchange_date;

  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_id, new.currency_in_id, new.exchange_date);

  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_id, new.currency_out_id, new.exchange_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_id, new.exchange_date);

  UPDATE account_balances
  SET exchanges_amount = exchanges_amount - new.amount_out
  WHERE account_id = new.account_id
    AND currency_id = new.currency_out_id;

  UPDATE account_daily_balances
  SET exchanges_amount = exchanges_amount - new.amount_out
  WHERE account_id = new.account_id
    AND currency_id = new.currency_out_id
    AND balance_date = new.exchange_date;

  UPDATE account_balances
  SET exchanges_amount = exchanges_amount + new.amount_in
  WHERE account_id = new.account_id
    AND currency_id = new.currency_in_id;

  UPDATE account_daily_balances
  SET exchanges_amount = exchanges_amount + new.amount_in
  WHERE account_id = new.account_id
    AND currency_id = new.currency_in_id
    AND balance_date = new.exchange_date;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND currency_id = old.currency_out_id
    AND balance_date = old.exchange_date
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND currency_id = old.currency_in_id
    AND balance_date = old.exchange_date
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_daily_balances
  WHERE account_id = new.account_id
    AND account_id != old.account_id
    AND currency_id = new.currency_out_id
    AND balance_date = new.exchange_date
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_daily_balances
  WHERE account_id = new.account_id
    AND account_id != old.account_id
    AND currency_id = new.currency_in_id
    AND balance_date = new.exchange_date
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_id
    AND activity_date = old.exchange_date
    AND NOT EXISTS (
      SELECT 1 FROM account_daily_balances
      WHERE account_id = old.account_id
        AND balance_date = old.exchange_date
    );

  DELETE FROM account_activity_dates
  WHERE account_id = new.account_id
    AND account_id != old.account_id
    AND activity_date = new.exchange_date
    AND NOT EXISTS (
      SELECT 1 FROM account_daily_balances
      WHERE account_id = new.account_id
        AND balance_date = new.exchange_date
    );
END;
`;
